var _g, _path, _g2, _path2, _g3, _g4, _path3, _path4, _g5, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDoorAttendant = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 61"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 351",
  d: "M346 293.158H166a15 15 0 01-15-15v-97.6c0-28.345 22.879-51.4 51-51.4h108c28.121 0 51 23.061 51 51.4v97.6a15 15 0 01-15 15z",
  fill: "#bfeafc"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 352",
  d: "M310 129.158h-54v164h90a15 15 0 0015-15v-97.6c0-28.345-22.879-51.4-51-51.4z",
  fill: "#bfe1fd"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 62"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 353",
  d: "M461 512H51a15 15 0 01-15-15V267a15 15 0 0115-15h410a15 15 0 0115 15v230a15 15 0 01-15 15z",
  fill: "#e1eeec"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 354",
  d: "M461 252H256v260h205a15 15 0 0015-15V267a15 15 0 00-15-15z",
  fill: "#d8e6e8"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 63"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 355",
  d: "M497 282H15a15 15 0 010-30h482a15 15 0 010 30z",
  fill: "#cfe3e5"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 64"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357",
  d: "M256 226.158a15 15 0 01-15-15v-67a15 15 0 0130 0v67a15 15 0 01-15 15z",
  fill: "#f9f9f9"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358",
  d: "M256 129.158v97a15 15 0 0015-15v-67a15 15 0 00-15-15z",
  fill: "#e2dff4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 359",
  d: "M497 252H256v30h241a15 15 0 000-30z",
  fill: "#c5e1e6"
})), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 361",
  d: "M256 144.295a72.148 72.148 0 1172.147-72.148A72.229 72.229 0 01256 144.295z",
  fill: "#ffe4c1"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 362",
  d: "M256 0v144.295A72.148 72.148 0 00256 0z",
  fill: "#fdd1a3",
  opacity: 0.56
})));
export default SvgDoorAttendant;